import { render, staticRenderFns } from "./tagView.vue?vue&type=template&id=1c08b97a&scoped=true&"
import script from "./tagView.vue?vue&type=script&lang=js&"
export * from "./tagView.vue?vue&type=script&lang=js&"
import style0 from "./tagView.vue?vue&type=style&index=0&id=1c08b97a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08b97a",
  null
  
)

export default component.exports